import { Iconify } from 'src/components/iconify';
import { SvgColor } from 'src/components/svg-color/svg-color';
import { CONFIG } from 'src/config-global';

const icon = (name: string) => (
  <SvgColor src={`${CONFIG.site.basePath}/assets/icons/navbar/${name}.svg`} />
);

export const ICONS = {
  job: icon('ic-job'),
  blog: icon('ic-blog'),
  chat: icon('ic-chat'),
  mail: icon('ic-mail'),
  user: icon('ic-user'),
  file: icon('ic-file'),
  lock: icon('ic-lock'),
  tour: icon('ic-tour'),
  order: icon('ic-order'),
  label: icon('ic-label'),
  blank: icon('ic-blank'),
  kanban: icon('ic-kanban'),
  folder: icon('ic-folder'),
  course: icon('ic-course'),
  banking: icon('ic-banking'),
  booking: icon('ic-booking'),
  invoice: icon('ic-invoice'),
  product: icon('ic-product'),
  calendar: icon('ic-calendar'),
  disabled: icon('ic-disabled'),
  external: icon('ic-external'),
  menuItem: icon('ic-menu-item'),
  ecommerce: icon('ic-ecommerce'),
  analytics: icon('ic-analytics'),
  dashboard: icon('ic-dashboard'),
  parameter: icon('ic-parameter'),
  profile: icon('ic-profile'),
  roles: icon('ic-external'),
  userInfo: <Iconify icon="gis:map-user" width="100" height="100"></Iconify>,
  subscription: icon('ic-subscription'),
  feedback: <Iconify icon="material-symbols:feedback" width="24" height="24"></Iconify>,
  projects: <Iconify icon="solar:notes-bold-duotone" />,
  settings: <Iconify icon="solar:settings-bold-duotone" />,
  security: <Iconify icon="solar:shield-keyhole-bold-duotone" />,
  cashOut: <Iconify icon="mdi:cash-fast" />,
  home: <Iconify icon="solar:home-angle-bold-duotone" />,
  withdraw: <Iconify icon="mdi:bank-transfer-out" />,
  pen: <Iconify icon="solar:pen-bold-duotone" />,
  chain: <Iconify icon="mdi:ethereum" />,
  token: <Iconify icon="mdi:coin" />,
  wallet: <Iconify icon="solar:wallet-bold-duotone" />,
};
